import { EmployeeIdentityResponse, EmployeeModel, PermissionGrant } from "@herbjoy/apex-api-models";
import { StateService } from "angular-ui-router";
import { FeatureManager } from "../../../core/feature-flags/feature-manager.service";
import { SessionService } from "../../../core/services/session.service";
import { UtilityService } from "../../../core/services/utility.service";
import { ROSTER_DIRECT_DEPOSIT, ROSTER_ROLES_EDITOR_V2, ROSTER_SEPARATE_EDIT_PAGES } from "../roster-flags";
import templateUrl from "./edit-employee-container.component.html";
import "./edit-employee-container.component.less";

export const EditEmployeeContainerComponent = {
    templateUrl,
    bindings: {
        employee: "<",
        routePermissions: "<",
        tabHeader: "<",
        identity: "<",
        featureManager: "<featureManagerSync",
        isImpersonated: "<"
    },
    controller: class {
        //@Input
        employee: EmployeeModel;
        //@Input
        routePermissions: PermissionGrant[];
        //@Input
        tabHeader: string;
        //@Input
        identity: EmployeeIdentityResponse;
        //@Input
        featureManager: FeatureManager;
        //@Input
        isImpersonated: boolean;
        features: { [s: string]: boolean };
        constructor(private $state: StateService, private sessionService: SessionService,
            private utilityService: UtilityService) {
            'ngInject';
        }

        $onInit() {
            this.features = {};
            this.features.separateEditPages = this.featureManager.isEnabled(ROSTER_SEPARATE_EDIT_PAGES);
            this.features.rolesEditorV2 = this.featureManager.isEnabled(ROSTER_ROLES_EDITOR_V2);
            this.features.directDeposit = this.featureManager.isEnabled(ROSTER_DIRECT_DEPOSIT);
        }

        onToggleBeta() {
            this.$state.reload();
        }

        onProxySignIn() {
            const proxied = this.sessionService.proxy(this.employee.Id)
                .then(function () {
                    window.location.href = "Home/Index";
                });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(proxied, "Proxying failed"));
        }
    }
};
